import { IndicatorBadge } from '@tribeplatform/react-ui-kit/IndicatorBadge'

import { useModerationCount } from '../../hooks/useModerationCount.js'

export const ModerationIndicatorBadge = ({ children, ...rest }) => {
  const { total } = useModerationCount()

  return (
    <IndicatorBadge count={total} {...rest}>
      {children}
    </IndicatorBadge>
  )
}
